"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function ApiExecutor(executor) {
  function handle(request) {
    return request.then(function (_ref) {
      var data = _ref.data,
          _bodyInit = _ref._bodyInit;
      return _bodyInit || data;
    });
  }
  /* eslint-disable no-param-reassign */


  function setSessionToken(token) {
    executor.defaults.headers.common.Authorization = "Bearer ".concat(token);
  }
  /* eslint-enable no-param-reassign */


  function getSessionToken() {
    var token = executor.defaults.headers.common.Authorization;

    if (token === undefined || token === 'Bearer undefined') {
      return null;
    }

    return executor.defaults.headers.common.Authorization;
  }

  function get(url, params, config) {
    return handle(executor.get(url, params, config));
  }

  function put(url, body) {
    return handle(executor.put(url, body));
  }

  function patch(url, body) {
    return handle(executor.patch(url, body));
  }

  function post(url, body, config) {
    return handle(executor.post(url, body, config));
  }

  function del(url) {
    return handle(executor["delete"](url));
  }

  function upload(url, body) {
    var headers = {
      'Content-Type': 'application/octet-stream'
    };
    return handle(executor.post(url, body, headers));
  }

  return {
    get: get,
    put: put,
    patch: patch,
    post: post,
    del: del,
    upload: upload,
    setSessionToken: setSessionToken,
    getSessionToken: getSessionToken
  };
}

var _default = ApiExecutor;
exports["default"] = _default;